define('modules/lonelyitem-product-addtocart',['jquery', 'connections/cart-connection', 'views/quick-cart'], function ($, CartConnection, QuickCart) {
  var LonelyItemProductAddToCart = (function () {
    function LonelyItemProductAddToCart() {}

    LonelyItemProductAddToCart.prototype.init = function () {
      var _this = this;

      $('body').on('click', '.button--lonelyitemadd', function () {
        _this.addToCart($(this));
      });
    };

    LonelyItemProductAddToCart.prototype.addToCart = function ($el) {
      var inputQuantity = $el.parent().find('.lonelyitem__sku-input--qty');
      var quantity = inputQuantity.val() || 1;
      var sku = $el.data('sku');
      var size = $el.data('size');
      var boxItems = $el.data('validateBox');

      if (boxItems && boxItems > 1) quantity = quantity * boxItems;

      var item = {
        sku: sku,
        quantity: quantity,
        size: size
      };

      CartConnection.add([item]).then(function (res) {
        QuickCart.printTotalQuantity(res);
      });
    };

    return LonelyItemProductAddToCart;
  })();

  return LonelyItemProductAddToCart;
});

